import Button from 'carbon-react/lib/components/button/__next__';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

const Container = styled.div<{ width?: string }>`
  padding: 5px;
  width: ${(props) => props.width || '100%'};
`;

const GoBackButton = ({
  url,
  width,
}: {
  url?: string | undefined;
  width?: string;
}) => {
  const navigate = useNavigate();
  const goBack = () => (url != null ? navigate(url) : navigate(-1));
  return (
    <Container width={width}>
      <Button variantType="tertiary" onClick={goBack} size="small">
        Back
      </Button>
    </Container>
  );
};

export default GoBackButton;
